import React from 'react';

type ConstrainWidthContainerProps = {
    children: React.ReactNode;
};
export function ConstrainWidthContainer({children}: ConstrainWidthContainerProps) {
    return <div className="max-w-3xl">{children}</div>;
}
